<section class="max-w-2xl mx-auto mt-16 w-10/12 sm:w-9/12 sm:text-justify">
  <h2 class="mb-10">{{ "privacy_policy_page.title" | translate }}</h2>
  <b>{{ "privacy_policy_page.intro" | translate }}</b>
  <ol class="pyg-upper-alpha">
    <li>
      {{ "privacy_policy_page.A1" | translate }}
      <a langRouterLink>https://pygmalios.com/</a>.
      {{ "privacy_policy_page.A2" | translate }}
    </li>
    <li>{{ "privacy_policy_page.B" | translate }}&nbsp;(“<b>GDPR</b>”).</li>
    <li>{{ "privacy_policy_page.C" | translate }}</li>
    <li>{{ "privacy_policy_page.D" | translate }}</li>
  </ol>

  <div class="pyg-decimal">
    <ol class="first-level">
      <li>
        {{ "privacy_policy_page.1.title" | translate }}
        <ol class="second-level basic-font">
          <li>{{ "privacy_policy_page.1_1.body" | translate }}</li>
          <li>
            {{ "privacy_policy_page.1_2.body" | translate }}
            <a [href]="'mailto:' + mail" target="_blank">{{ mail }}</a
            >.
          </li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.2.title" | translate }}
        <p>{{ "privacy_policy_page.2.body" | translate }}</p>
        <ol class="second-level">
          <li>
            {{ "privacy_policy_page.2_1.title" | translate }}
            <p>{{ "privacy_policy_page.2_1.body" | translate }}</p>
          </li>
          <li>
            {{ "privacy_policy_page.2_2.title" | translate }}
            <p>{{ "privacy_policy_page.2_2.body" | translate }}</p>
          </li>
          <li>
            {{ "privacy_policy_page.2_3.title" | translate }}
            <ol class="third-level">
              <li>
                {{ "privacy_policy_page.2_3_1.title" | translate }}
                <ol class="basic-font">
                  <li>{{ "privacy_policy_page.2_3_1_1.body" | translate }}</li>
                  <li>{{ "privacy_policy_page.2_3_1_2.body" | translate }}</li>
                </ol>
              </li>
              <li>
                {{ "privacy_policy_page.2_3_2.title" | translate }}
                <ol class="basic-font">
                  <li>{{ "privacy_policy_page.2_3_2_1.body" | translate }}</li>
                  <li>{{ "privacy_policy_page.2_3_2_2.body" | translate }}</li>
                </ol>
              </li>
              <li>
                {{ "privacy_policy_page.2_3_3.title" | translate }}
                <ol class="basic-font">
                  <li>
                    {{ "privacy_policy_page.2_3_3_1.body" | translate }}
                    <a langRouterLink="privacy-policy"
                      >https://pygmalios.com/privacy-policy</a
                    >
                  </li>
                  <li>{{ "privacy_policy_page.2_3_3_2.body" | translate }}</li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.3.title" | translate }}
        <p>{{ "privacy_policy_page.3.body" | translate }}</p>
        <ol>
          <li>
            {{ "privacy_policy_page.3_1.title" | translate }}
            <div>
              <p>
                {{ "privacy_policy_page.3_1.body.paragraph1" | translate }}
                <br /><br />
                {{ "privacy_policy_page.3_1.body.paragraph2" | translate }}
                <br /><br />
                {{ "privacy_policy_page.3_1.body.paragraph3.body" | translate }}
              </p>
              <ul>
                <li>
                  {{
                    "privacy_policy_page.3_1.body.paragraph3.point1" | translate
                  }}
                </li>
                <li>
                  {{
                    "privacy_policy_page.3_1.body.paragraph3.point2" | translate
                  }}
                  <a [href]="'mailto:' + mail" target="_blank">{{ mail }}</a
                  >.
                </li>
              </ul>
            </div>
          </li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.4.title" | translate }}
        <ol class="second-level basic-font">
          <li>{{ "privacy_policy_page.4_1.body" | translate }}</li>
          <li>
            {{ "privacy_policy_page.4_2.body" | translate }}
            <ol class="third-level basic-font">
              <li>
                {{ "privacy_policy_page.4_2_1.title" | translate }}
                <div>
                  <p>
                    {{
                      "privacy_policy_page.4_2_1.body.paragraph1" | translate
                    }}
                    <br /><br />
                    {{
                      "privacy_policy_page.4_2_1.body.paragraph2" | translate
                    }}
                  </p>
                  <div>
                    <p>
                      Google Ireland Limited,
                      <br />Google Building Gordon House, <br />Barrow St,
                      Dublin 4, <br />Ireland
                    </p>
                    <p>
                      LinkedIn Ireland Unlimited Company
                      <br />Wilton Plaza <br />Wilton Place, Dublin 2
                      <br />Ireland
                    </p>
                    <p>
                      Smartlook.com, s.r.o.
                      <br />Šumavská 524/31 <br />602 00 Brno <br />Czech
                      Republic
                    </p>
                    <p>
                      Liidio Oy / Leadfeeder
                      <br />Keskuskatu 6 E <br />00100 Helsinki <br />FINLAND
                    </p>
                    <p>
                      {{
                        "privacy_policy_page.4_2_1.body.paragraph1" | translate
                      }}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                {{ "privacy_policy_page.4_2_2.title" | translate }}
                <p>{{ "privacy_policy_page.4_2_2.body" | translate }}</p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.5.title" | translate }}
        <ol class="second-level basic-font">
          <li>
            {{ "privacy_policy_page.5_1.body" | translate }}
            <a [href]="'mailto:' + mail" target="_blank">{{ mail }}</a
            >.
          </li>
          <li>{{ "privacy_policy_page.5_2.body" | translate }}</li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.6.title" | translate }}
        <ol class="second-level basic-font">
          <li>{{ "privacy_policy_page.6_1.body" | translate }}</li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.7.title" | translate }}
        <ol class="second-level basic-font">
          <li>
            <b>{{ "privacy_policy_page.7_1.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_1.body" | translate }}
          </li>
          <li>
            <b>{{ "privacy_policy_page.7_2.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_2.body" | translate }}
          </li>
          <li>
            <b>{{ "privacy_policy_page.7_3.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_3.body" | translate }}
          </li>
          <li>
            <b>{{ "privacy_policy_page.7_4.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_4.body" | translate }}
          </li>
          <li>
            <b>{{ "privacy_policy_page.7_5.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_5.body" | translate }}
          </li>
          <li>
            {{ "privacy_policy_page.title" | translate }}
            <b>{{ "privacy_policy_page.7_6.title" | translate }}</b>
            -
            {{ "privacy_policy_page.7_6.body.paragraph1" | translate }}
            <a [href]="'mailto:' + mail" target="_blank">{{ mail }}</a
            >.
            {{ "privacy_policy_page.7_6.body.paragraph2" | translate }}
          </li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.8.title" | translate }}
        <ol class="second-level basic-font">
          <li>{{ "privacy_policy_page.8_1.body" | translate }}</li>
        </ol>
      </li>
      <li>
        {{ "privacy_policy_page.title" | translate }}
        {{ "privacy_policy_page.9.title" | translate }}
        <ol class="second-level basic-font">
          <li>
            {{ "privacy_policy_page.title" | translate }}
            {{ "privacy_policy_page.9_1.body" | translate }}
            <a [href]="'mailto:' + mail" target="_blank">{{ mail }}</a
            >.
          </li>
        </ol>
      </li>
    </ol>
  </div>
  <button
    class="mt-14 font-bold rounded-r-full rounded-l-full h-12 w-full max-w-md cursor-pointer"
    langRouterLink
  >
    {{ "buttons.back_home" | translate }}
  </button>
</section>
<hr class="w-10/12 lg:w-11/12 mx-auto mt-16" />
